import { FC } from 'react'
import cn from 'classnames'

import { CryptoRewardsOrderStatus as CryptoRewardsOrderStatusType } from 'components/features/rewards/rewardsPane/types/orderResult'

import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsOrderStatus/CryptoRewardsOrderStatus.styl'

type CryptoRewardsOrderStatusProps = {
  orderStatus: CryptoRewardsOrderStatusType
}

export const CryptoRewardsOrderStatus: FC<CryptoRewardsOrderStatusProps> = ({ orderStatus }) => {

  return (
    <span className={ cn(styles.status, styles[orderStatus]) }>
      { orderStatus === 'completed' && 'Filled'}
      { orderStatus === 'pending' && 'Pending'}
      { orderStatus === 'cancelled' && 'Cancelled'}
    </span>
  )
}
